import { render, staticRenderFns } from "./TermsAndConditions2.vue?vue&type=template&id=2878feda&scoped=true"
import script from "./TermsAndConditions2.vue?vue&type=script&lang=js"
export * from "./TermsAndConditions2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2878feda",
  null
  
)

export default component.exports